<template>
  <div :class="headerClassName">
    <div class="left">
      <div v-if="type === 'questionnaire'" @click="$router.back(-1)" class="backBlock">
        <div class="arrow"></div>
        <p>Back</p>
      </div>
    </div>
    <div class="center">
      <a href="https://life.femometer.com">
        <img class="mainLogo" src="@/assets/logo.png" alt="">
      </a>
    </div>
    <div class="right">
      <router-link :to="{path: '/questionnaire'}">
        <img class="homeLogo" src="@/assets/icon/home.png" alt="">
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    type: String,
  },
  computed:{
    headerClassName(){
      console.log(this)
      console.log(this.$route)
      return this.$route.name.indexOf('section') !== -1 || this.$route.name === 'begin'? 'header': 'header pink'
      // return 'header'
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.header{
  position: fixed;
  z-index: 10;
  box-sizing: border-box;
  width: 100%;
  height: var(--pc_header_height);
  padding: 30px 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background-color: var(--background-color);
  .left{
    width: 100px;
    .backBlock{
      display: flex;
      align-items: center;
      cursor: pointer;
      .arrow{
        height: 10px;
        width: 10px;
        border-left: solid 2px #000;
        border-bottom: solid 2px #000;
        transform:rotate(45deg);
      }
      p{
        margin-bottom: 0;
        margin-left: 10px;
        font-family: var(--font_family_semibold);
        font-size: 18px;
        font-weight: bold;
        text-transform: capitalize;
      }
    }
  }
  .right{
    width: 100px;
    display: flex;
    justify-content: flex-end;
  }
  .mainLogo{
    width: 170px;
  }
  .homeLogo{
    width: 27px;
    height: 27px;
  }
}
.pink{
  background-color: #fbf3ed;
}
@media only screen and (max-width: 767px){
  .header{
    padding: 15px;
    height: var(--m_header_height);
    .left{
      .backBlock{
        .arrow{
          height: 8px;
          width: 8px;
          border-left: solid 1px #000;
          border-bottom: solid 1px #000;
          transform:rotate(45deg);
        }
        p{
          margin-bottom: -2px;
          margin-left: 6px;
          font-family: var(--font_family_semibold);
          font-size: 14px;
          font-weight: bold;
          text-transform: capitalize;
        }
      }
    }
    .mainLogo{
      width: 100px;
    }
    .homeLogo{
      width: 15px;
      height: 15px;
    }
  }
}
</style>
